import { useState, type FormEvent } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../../api';
import { useMe } from '../../hooks';

export default function Password() {
  const me = useMe();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    if (next.length < 4) {
      setError('新密码至少 4 位');
      return;
    }
    if (next !== confirm) {
      setError('两次输入的新密码不一致');
      return;
    }
    setBusy(true);
    try {
      await api('/api/auth/password', {
        method: 'POST',
        body: JSON.stringify({ current, next }),
      });
      await queryClient.invalidateQueries({ queryKey: ['me'] });
      navigate('/', { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.code === 'invalid_current_password') {
        setError('当前密码不正确');
      } else {
        setError('修改失败，请稍后再试');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 520 }}>
      <div className="page-head">
        <div>
          <div className="eyebrow">Account</div>
          <h1>{me.data?.must_change_password ? '设置新密码' : '修改密码'}</h1>
        </div>
      </div>

      <form className="side-card" onSubmit={submit}>
        {me.data?.must_change_password ? (
          <div
            className="badge warn"
            style={{ height: 'auto', padding: '10px 12px', marginBottom: 18, whiteSpace: 'normal' }}
          >
            首次登录，请先把初始密码改成你自己的密码。
          </div>
        ) : null}

        {error ? <div className="error">{error}</div> : null}

        <div className="field">
          <label htmlFor="current">当前密码</label>
          <input
            id="current"
            className="input"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="next">新密码（至少 4 位，测试期建议 8 位以上）</label>
          <input
            id="next"
            className="input"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            minLength={4}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="confirm">再次输入新密码</label>
          <input
            id="confirm"
            className="input"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={4}
            required
          />
        </div>

        <p className="muted" style={{ fontSize: 11, marginBottom: 14 }}>
          测试期允许 4 位密码；对外开放或增加人员前建议收紧到 8 位以上。
        </p>

        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? '保存中…' : '保存新密码'}
        </button>
      </form>
    </div>
  );
}